export const MOBILE_APP_USER_COLUMNS = [
    {
        field: 'fullName',
        headerName: 'Full Name',
        width: 200,
    },
    {
        field: 'phoneNumber',
        headerName: 'Phone Number',
        width: 150,
    },
    {
        field: 'customerName',
        headerName: 'Customer',
        width: 200,
    },
    {
        field: 'appStatus',
        headerName: 'App Status',
        width: 120,
    },
    {
        field: 'appVersion',
        headerName: 'App Version',
        width: 120,
    },
    {
        field: 'osVersion',
        headerName: 'OS Version',
        width: 130,
    },
    {
        field: 'createdAt',
        headerName: 'Created',
        width: 150,
    },
    {
        field: 'updatedAt',
        headerName: 'Last Updated',
        width: 150,
    },
];
